import { useQuery } from '@tanstack/react-query'
import { offerRepositoryApi } from '../../../lib/api'
import { pickTitleFlowOffers } from '../../../lib/onboarding/pickOnboardingOffers'
import { recommendedPlanFromOfferCount } from '../../../lib/onboarding/onboardingConstants'

export interface OnboardingAccountInsights {
  totalOffers: number
  weakTitleCandidates: number
  catalogHoursEstimate: number
  recommendedPlan: 'STANDARD' | 'VIP'
}

const MINUTES_PER_TITLE_MANUAL = 8

async function fetchInsights(accountId: number): Promise<OnboardingAccountInsights> {
  const qs = new URLSearchParams({
    account_id: String(accountId),
    page: '1',
    limit: '1',
  })
  const { data } = await offerRepositoryApi.get<{ total?: number }>(
    `/allegro/offers-management?${qs}`,
  )
  const totalOffers = data.total ?? 0

  let weakTitleCandidates = 0
  try {
    const ids = await pickTitleFlowOffers(accountId)
    weakTitleCandidates = ids.length
  } catch {
    weakTitleCandidates = 0
  }

  const catalogHoursEstimate = Math.max(
    1,
    Math.round((totalOffers * MINUTES_PER_TITLE_MANUAL) / 60),
  )

  return {
    totalOffers,
    weakTitleCandidates,
    catalogHoursEstimate,
    recommendedPlan: recommendedPlanFromOfferCount(totalOffers) ?? 'STANDARD',
  }
}

export function useOnboardingAccountInsights(accountId: number | undefined, enabled = true) {
  return useQuery({
    queryKey: ['onboarding', 'insights', accountId],
    queryFn: () => fetchInsights(accountId!),
    enabled: enabled && !!accountId,
    staleTime: 120_000,
  })
}
